import './Icon_Bookmark.css';
 
function Icon_Bookmark() {
  return (
    <div className='icon-container-bookmark'>
      <svg viewBox="0 0 24 24" className="bookmark-svg">
        <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
      </svg>
    </div>
  );
}
 
export default Icon_Bookmark;
 